import { createAction, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { CoreMsgTypes, UserAccountRecord } from '@tassat/fred-definitions';

export interface UserAccountsState {
    [key: string]: UserAccountRecord;
}

const initialState: UserAccountsState = {};

const initialLoadAction = createAction<{ userAccounts: UserAccountsState }>('InitialLoad');
const newACGMappingAction = createAction<{ userAccounts: UserAccountsState }>('NewACGMapping');
const userAccountRecordAction = createAction<UserAccountRecord>(CoreMsgTypes.UserAccountRecord);

const userAccountsSlice = createSlice({
    name: 'userAccounts',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userAccountRecordAction, (state, action) => {
                state[action.payload.UserAccountId] = action.payload;
            })
            .addMatcher(isAnyOf(initialLoadAction, newACGMappingAction), (state, action) => {
                Object.assign(state, action.payload.userAccounts);
            });
    }
});

export default userAccountsSlice.reducer;